// @TODO: <HEALTH2019>
(function () {
    App.directive('healthComplaintRefundListDetails', healthComplaintRefundListDetailsDirective);
    healthComplaintRefundListDetailsDirective.$inject = ['Config'];

    function healthComplaintRefundListDetailsDirective(Config) {
        return {
            restrict: 'E',
            scope: {
                details: '<'
            },
            templateUrl: Config.TEMPLATES_DIR + 'Components/health-complaint-refund-list-details.html',
            controller: HealthComplaintRefundListDetailsController,
            controllerAs: '$ctrl',
            bindToController: true
        }
    }

    HealthComplaintRefundListDetailsController.$inject = [];

    function HealthComplaintRefundListDetailsController() {
        var self = this;

        self.getContactType = function (details) {
            switch (details.contactType) {
                case 'PHONE':
                    return 'Telefon';
                case 'EMAIL':
                    return 'E-mail';
            }
        }
    }
})();
// @TODO: </HEALTH2019>
